import React, { useEffect } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import FormTextField from "../components/common/FormTextField";
import FormSelectField from "../components/common/FormSelectField";
import SubmitButton from "../components/buttons/SubmitButton";
import SyncAltIcon from "@mui/icons-material/SyncAlt";

import {
  adjustFiscalStock,
  getStockIoTypes,
} from "../redux/actions/fiscalActions";

const schema = Yup.object({
  adjustmentQty: Yup.number()
    .required("Adjustment quantity is required")
    .notOneOf([0], "Quantity cannot be zero"),
  type: Yup.string().required("Adjustment reason type is required"),
  notes: Yup.string().required("Notes are required for stock adjustments"),
});

const AdjustStockForm = ({ item, loading }) => {
  const dispatch = useDispatch();
  const { lookups } = useSelector((state) => state.fiscal);

  useEffect(() => {
    if (lookups.stockIoTypes.data.length === 0) dispatch(getStockIoTypes());
  }, [dispatch, lookups]);

  // Adjustments usually use Stock IO Types from KRA (e.g. 06 for Inventory differences)
  const ioOpts = lookups.stockIoTypes.data.map((io) => ({
    value: io.code,
    label: `${io.code} - ${io.name}`,
  }));

  return (
    <Formik
      initialValues={{ adjustmentQty: "", type: "", notes: "" }}
      validationSchema={schema}
      onSubmit={(values) => {
        dispatch(adjustFiscalStock({ productId: item.productId, ...values }));
      }}
    >
      {({ isValid }) => (
        <Form>
          <Stack spacing={2}>
            <Box
              p={2}
              bgcolor="background.default"
              borderRadius={1}
              border="1px solid"
              borderColor="divider"
            >
              <Typography variant="caption" color="text.secondary">
                Item:
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {item.name}
              </Typography>
              <Typography
                variant="caption"
                display="block"
                color="text.secondary"
              >
                Current eTIMS Stock: <b>{item.stock}</b>
              </Typography>
            </Box>

            <FormTextField
              name="adjustmentQty"
              label="Adjustment Quantity (Use negative for deduction)"
              type="number"
            />
            <FormSelectField
              name="type"
              label="Adjustment Reason Code"
              options={ioOpts}
              searchable
            />
            <FormTextField
              name="notes"
              label="Notes / Remarks"
              multiline
              rows={2}
            />

            <SubmitButton
              title="Push Stock Adjustment"
              loading={loading}
              disabled={!isValid || loading}
              startIcon={<SyncAltIcon />}
            />
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
export default AdjustStockForm;
